export default [
  {
    label: 'DATA',
    route: 'data',
    children: [
      {
        label: 'Our Data',
        route: 'our-data',
        langSplit: true
      },
      {
        label: 'Our Idea',
        route: 'our-idea',
        langSplit: true
      },
      {
        label: 'Our Brand',
        route: 'our-brand',
        langSplit: true
      }
    ]
  },
  {
    label: 'GAK',
    route: 'gak',
    children: [
      {
        label: 'GAK SEJONG',
        route: 'gak-sejong',
        langSplit: true
      },
      {
        label: 'GAK CHUNCHEON',
        route: 'gak-chuncheon',
        langSplit: true
      },
      {
        label: 'GAK GLOBAL',
        route: 'gak-global',
        langSplit: true
      }
    ]
  },
  {
    label: 'TECH',
    route: 'tech',
    children: [
      {
        label: 'Technology',
        route: 'technology',
        langSplit: true,
      },
    ],
  },
  {
    label: 'ESG',
    route: 'esg',
    children: [
      {
        label: 'Green Energy',
        route: 'green-energy'
      },
      {
        label: 'LEED Platinum',
        route: 'leed-platinum',
        langSplit: true
      }
    ]
  }
];
